import { createAction } from '@reduxjs/toolkit';
import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import {
  ATTRS_ANALYTICS_FLOW_NAME,
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
  ATTRS_DESCRIPTION,
  SpanName,
} from 'core/common/observability/entities';
import { AppThunk } from 'core/common/store';
import { getAppLink } from '../selectors';

export const fetchNebulaAppLinkPending = createAction('user/FETCH_NEBULA_APP_LINK/pending');
export const fetchNebulaAppLinkSucceed = createAction<string>('user/FETCH_NEBULA_APP_LINK/succeed');
export const fetchNebulaAppLinkFailed = createAction<string>('user/FETCH_NEBULA_APP_LINK/failed');

export const fetchNebulaAppLink =
  (host: string): AppThunk =>
  async (dispatch, getState, context) => {
    const {
      loggingService,
      userService,
      observabilitySystem,
      funnelSettingsService,
      errorMonitoringService,
      appEnvironment,
    } = context;
    dispatch(fetchNebulaAppLinkPending());

    const spanAttributes = {
      [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
      [ATTRS_ANALYTICS_FLOW_NAME]: funnelSettingsService.getFlowName(),
      [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
      [ATTRS_DESCRIPTION]: appEnvironment.getPlatform(),
    };

    const span = observabilitySystem.startSpan(SpanName.CREATE_NEBULA_APP_LINK);
    span.setAttributes(spanAttributes);

    try {
      const link = await userService.getNebulaAppLink(host);

      dispatch(fetchNebulaAppLinkSucceed(link));
      span.succeed();
    } catch (e) {
      const appLink = getAppLink(getState());

      const link = appLink || host;

      dispatch(fetchNebulaAppLinkFailed(link));
      const err = normalizeError(e);
      loggingService.error(err);

      errorMonitoringService.captureError(err, {
        tags: {
          get_params: location.search || notAvailable,
          error_message: err.message,
          error_reason: 'nebula_app_link',
        },
      });

      span.fail(err);
    }
  };
